var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('router-view',{staticClass:"h-100"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }